// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

* {
  font-family: "Montserrat", sans-serif !important;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  white-space: nowrap;
  border: 0;
}

.select {
  width: 410px;
}

body {
  -webkit-font-smoothing: antialiased;
}

hr {
  height: 1px;
  background: #444343;
  border: none;
}

.dob-label {
  margin-top: 20px;
}

.disabledColor {
  background: rgb(227, 227, 227);
  opacity: 0.6;
  color: black;
  font-weight: 600;
}

.gutter-80 {
  max-width: 1800px;
  padding: 20px 9px;
  margin: 0 auto;
  width: 80%;
}

.gutter-90 {
  max-width: 1800px;
  padding: 20px 9px;
  margin: 0 auto;
  width: 90%;
}

.gutter-95 {
  padding: 20px 9px;
  margin: 0 auto;
  width: 95%;
  margin-top: -10px;
}

.grade-gutter-90 {
  max-width: 1800px;
  margin: 0 auto;
  width: 90%;
}
.grade-gutter-90 .will-be {
  text-decoration: underline;
}
.grade-gutter-90 .bold {
  font-weight: 650;
}

.link-color {
  color: #0669B3;
}

.out-of-bounds-container {
  display: flex;
  flex-direction: row;
  height: 500px;
  justify-content: center;
  width: 100%;
}
.out-of-bounds-container .out-of-bounds {
  border-radius: 10px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #818181;
  align-items: center;
  background: #D1D3D4;
  border: 2px solid #A7A9AC;
  display: flex;
  flex-direction: column;
  height: 50%;
  padding: 50px;
  width: 80%;
}
.out-of-bounds-container hr {
  color: #444343;
  width: 90%;
}

.top-label {
  color: #19608f;
  font-size: 1.2rem;
  font-weight: 600;
  padding: none;
}

.top-label-secondary-text {
  color: #19608f;
  margin-bottom: 15px;
  font-weight: 500;
}

.yellow-box {
  border-radius: 4px;
  background: #FEBF31;
  padding: 3px 10px;
  font-weight: 600;
}

.select {
  border: none;
  background: #EDf0F1;
  border-radius: 5px;
  padding: 5px 10px;
  border: 1px solid #A7A9AC;
}

.current-entitlement-table {
  max-height: 800px;
  overflow-y: auto;
  contain: layout;
}
.current-entitlement-table table {
  border-collapse: separate;
  border-spacing: 0px;
  width: 100%;
}
.current-entitlement-table table thead > tr > th {
  border-radius: 5px 5px 0 0;
  background-color: #C0DEF0;
  border-color: #A7A9AC;
  border-style: solid;
  border-width: 1px;
  color: #19608f;
  font-size: 0.85rem;
  font-weight: 500;
  padding: 5px;
  text-align: center;
}
.current-entitlement-table table tbody > tr {
  border-left: 1px solid #A7A9AC;
  border-right: 1px solid #A7A9AC;
}
.current-entitlement-table table tbody > tr.stripe {
  background-color: #EDf0F1;
}
.current-entitlement-table table tbody > tr > td {
  border: 1px solid #D1D3D4;
  height: 50px;
  font-size: 0.78rem;
  font-size: 0.85rem;
  padding: 5px 5px 5px 10px;
  height: 500 !important;
}
.current-entitlement-table table tbody > tr > td.email {
  max-width: 10%;
  width: 180px;
  word-wrap: anywhere;
}
.current-entitlement-table table td.center {
  text-align: center;
}
.current-entitlement-table table tbody > tr > td.first {
  border-left: 1px solid #A7A9AC;
}
.current-entitlement-table table tbody > tr > td.last {
  border-right: 1px solid #A7A9AC;
}
.current-entitlement-table table tfoot > tr {
  background-color: white;
}
.current-entitlement-table table tfoot > tr > td {
  border-top: 1px solid #A7A9AC;
  padding-top: 10px;
}
.current-entitlement-table table tfoot > tr > td > div {
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  margin: 0 auto;
}
.current-entitlement-table table tfoot > tr > td > div > .showing-records {
  font-size: 0.8rem;
  font-style: italic;
  margin-top: 5px;
  position: absolute;
  right: 4%;
}
.current-entitlement-table table .special-cell {
  vertical-align: top;
}
.current-entitlement-table table .job-name {
  width: 300px;
}
.current-entitlement-table table .special-cell-mapping {
  vertical-align: top;
  text-align: center;
}
.current-entitlement-table table .edit {
  width: 50px;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/global/Global.scss","webpack://./src/styles/global/globalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AAPA;EACI,gDAAA;AAUJ;;AANA;EACI,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,mBAAA;EACA,SAAA;AASJ;;AANA;EACI,YAAA;AASJ;;AALA;EACI,mCAAA;AAQJ;;AALA;EACI,WAAA;EACA,mBDFK;ECGL,YAAA;AAQJ;;AALA;EACI,gBAAA;AAQJ;;AALA;EACI,8BAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;AAQJ;;AALA;EACI,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,UAAA;AAQJ;;AALA;EACI,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,UAAA;AAQJ;;AALA;EACI,iBAAA;EACA,cAAA;EACA,UAAA;EACA,iBAAA;AAQJ;;AALA;EACI,iBAAA;EACA,cAAA;EACA,UAAA;AAQJ;AANI;EACI,0BAAA;AAQR;AALI;EACI,gBAAA;AAOR;;AAHA;EACI,cDlDS;ACwDb;;AAHA;EACI,aAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;AAMJ;AAJI;ECxFA,mBDyF0B;ECpE1B,2CAAA;EDsEI,mBAAA;EACA,mBDxEA;ECyEA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,aAAA;EACA,UAAA;AAMR;AAHI;EACI,cD7EC;EC8ED,UAAA;AAKR;;AADA;EACI,cDzGM;EC0GN,iBAAA;EACA,gBAAA;EACA,aAAA;AAIJ;;AADA;EACI,cDhHM;ECiHN,mBAAA;EACA,gBAAA;AAIJ;;AADA;ECxHI,kBDyHsB;EACtB,mBDzGQ;EC0GR,iBAAA;EACA,gBAAA;AAIJ;;AADA;EACI,YAAA;EACA,mBD/GI;ECgHJ,kBAAA;EACA,iBAAA;EACA,yBAAA;AAIJ;;AACA;EACI,iBAAA;EACA,gBAAA;EACA,eAAA;AAEJ;AAAI;EACI,yBAAA;EACA,mBAAA;EACA,WAAA;AAER;AAAQ;ECnJJ,0BDoJ8B;EACtB,yBD1HA;EC2HA,qBDjIJ;ECkII,mBAAA;EACA,iBAAA;EACA,cDtJF;ECuJE,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;AAEZ;AACQ;EACI,8BAAA;EACA,+BAAA;AACZ;AAEQ;EACI,yBDpJJ;ACoJR;AAGQ;EACI,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;AADZ;AAIQ;EACI,cAAA;EACA,YAAA;EACA,mBAAA;AAFZ;AAKQ;EACI,kBAAA;AAHZ;AAMQ;EACI,8BAAA;AAJZ;AAOQ;EACI,+BAAA;AALZ;AAQQ;EACI,uBAAA;AANZ;AASQ;EACI,6BAAA;EACA,iBAAA;AAPZ;AAUQ;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,cAAA;AARZ;AAWQ;EACI,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,SAAA;AATZ;AAYQ;EACI,mBAAA;AAVZ;AAaQ;EACI,YAAA;AAXZ;AAcQ;EACI,mBAAA;EACA,kBAAA;AAZZ;AAeQ;EACI,WAAA;AAbZ","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n$lt-blue: #7DB7CC;\n$dk-blue: #19608f;\n$dashboard-blue: #0d6efd;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n// $DCSD-logo-green: #84ae30; // old - does not pass\n// $DCSD-logo-green: #94B741; // this is the color from district site (see kellys screen shot)\n$DCSD-logo-green: #577d00; // darker green but does pass in FF\n$text: #414042;\n$white: #EDEDED;\n$shadow: #818181;\n$shadow2: #525151;\n$red: #CB321A;\n$green: #C7CC68;\n$highlight: #FDF9D0;\n$important: #FEBF31;\n$grey0: #EDf0F1;\n$grey0b: #e8e8e8; // new grey color\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$grey5: #333;\n$pale-blue: #C0DEF0;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n$accessibility-red: rgb(218, 18, 18);\n","@import \"../../styles/global/Colors\";\n@import \"../../styles/global/globalMixins\";\n\n* {\n    font-family: \"Montserrat\", sans-serif !important;\n}\n\n// screen reader accessibility hidden!\n.sr-only {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    margin: -1px;\n    padding: 0;\n    overflow: hidden;\n    white-space: nowrap;\n    border: 0;\n}\n\n.select {\n    width: 410px;\n}\n\n// This is used for \"bolding\" text in chrome\nbody {\n    -webkit-font-smoothing: antialiased;\n}\n\nhr {\n    height: 1px;\n    background: $grey4a;\n    border: none;\n}\n\n.dob-label {\n    margin-top: 20px;\n}\n\n.disabledColor {\n    background: rgb(227, 227, 227);\n    opacity: .6;\n    color: black;\n    font-weight: 600;\n}\n\n.gutter-80 {\n    max-width: 1800px;\n    padding: 20px 9px;\n    margin: 0 auto;\n    width: 80%;\n}\n\n.gutter-90 {\n    max-width: 1800px;\n    padding: 20px 9px;\n    margin: 0 auto;\n    width: 90%;\n}\n\n.gutter-95 {\n    padding: 20px 9px;\n    margin: 0 auto;\n    width: 95%;\n    margin-top: -10px;\n}\n\n.grade-gutter-90 {\n    max-width: 1800px;\n    margin: 0 auto;\n    width: 90%;\n\n    .will-be {\n        text-decoration: underline;\n    }\n\n    .bold {\n        font-weight: 650;\n    }\n}\n\n.link-color {\n    color: $pearl-blue\n}\n\n.out-of-bounds-container {\n    display: flex;\n    flex-direction: row;\n    height: 500px;\n    justify-content: center;\n    width: 100%;\n\n    .out-of-bounds {\n        @include borderRadius(10px);\n        @include shadow();\n        align-items: center;\n        background: $grey1;\n        border: 2px solid $grey2;\n        display: flex;\n        flex-direction: column;\n        height: 50%;\n        padding: 50px;\n        width: 80%;\n    }\n\n    hr {\n        color: $grey4a;\n        width: 90%;\n    }\n}\n\n.top-label {\n    color: $dk-blue;\n    font-size: 1.2rem;\n    font-weight: 600;\n    padding: none;\n}\n\n.top-label-secondary-text {\n    color: $dk-blue;\n    margin-bottom: 15px;\n    font-weight: 500;\n}\n\n.yellow-box {\n    @include borderRadius(4px);\n    background: $important;\n    padding: 3px 10px;\n    font-weight: 600;\n}\n\n.select {\n    border: none;\n    background: $grey0;\n    border-radius: 5px;\n    padding: 5px 10px;\n    border: 1px solid $grey2;\n}\n\n\n// Below is the styling for the table of current entitlements by job profile\n.current-entitlement-table {\n    max-height: 800px;\n    overflow-y: auto; // scrollable\n    contain: layout;\n\n    table {\n        border-collapse: separate;\n        border-spacing: 0px;\n        width: 100%;\n\n        thead>tr>th {\n            @include borderRadius(5px 5px 0 0);\n            background-color: $pale-blue;\n            border-color: $grey2;\n            border-style: solid;\n            border-width: 1px;\n            color: $dk-blue;\n            font-size: 0.85rem;\n            font-weight: 500;\n            padding: 5px;\n            text-align: center;\n        }\n\n        tbody>tr {\n            border-left: 1px solid $grey2;\n            border-right: 1px solid $grey2;\n        }\n\n        tbody>tr.stripe {\n            background-color: $grey0;\n        }\n\n        tbody>tr>td {\n            border: 1px solid $grey1;\n            height: 50px;\n            font-size: 0.78rem;\n            font-size: 0.85rem;\n            padding: 5px 5px 5px 10px;\n            height:500 !important;\n        }\n\n        tbody>tr>td.email {\n            max-width: 10%;\n            width: 180px;\n            word-wrap: anywhere;\n        }\n\n        td.center {\n            text-align: center;\n        }\n\n        tbody>tr>td.first {\n            border-left: 1px solid $grey2;\n        }\n\n        tbody>tr>td.last {\n            border-right: 1px solid $grey2;\n        }\n\n        tfoot>tr {\n            background-color: white;\n        }\n\n        tfoot>tr>td {\n            border-top: 1px solid $grey2;\n            padding-top: 10px;\n        }\n\n        tfoot>tr>td>div {\n            display: flex;\n            flex-direction: row;\n            justify-content: center;\n            width: 100%;\n            margin: 0 auto;\n        }\n\n        tfoot>tr>td>div>.showing-records {\n            font-size: 0.8rem;\n            font-style: italic;\n            margin-top: 5px;\n            position: absolute;\n            right: 4%;\n        }\n\n        .special-cell {\n            vertical-align: top;\n        }\n\n        .job-name {\n            width: 300px;\n        }\n\n        .special-cell-mapping {\n            vertical-align: top;\n            text-align: center;\n        }\n\n        .edit {\n            width: 50px;\n        }\n    }\n}\n","@import \"./Colors.scss\";\n\n@mixin borderRadius($radius: 5px) {\n    border-radius: $radius;\n}\n\n@mixin dialogueBold() {\n    font-weight: 600;\n    font-size: .9em;\n}\n\n@mixin input() {\n    border-radius: 5px;\n    font-weight: 400;\n    width: 100%;\n}\n\n@mixin infoRounded($radius) {\n    background: $information;\n    border-bottom-left-radius: $radius;\n    border-bottom-right-radius: $radius;\n}\n\n@mixin shadow() {\n    box-shadow: 0.1rem 0.15rem 0.3rem 0 $shadow;\n}\n@mixin shadowBottom() {\n    box-shadow: 0 0.1rem 0.15rem 0 $shadow;\n}\n@mixin standardInputContainer() {\n    font-weight: 500;\n    font-size: .9rem;\n    margin: 10px 0;\n}\n@mixin standardInput() {\n    @include borderRadius(5px);\n    border: none;\n    border: 1px solid $grey3;\n    padding: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
